/**
 * Keep the first occurrence of each id, drop the rest, preserve order.
 *
 * The stores hold optimistic local rows alongside rows that later arrive from
 * Supabase; when both survive, list surfaces render the same record twice (the
 * Add Items panel in ItemPoolEditor did — finding F14,
 * docs/9-exploration/MOSSO-DEMO-FINDINGS-2026-08-25.md). Dedupe where the list
 * is derived rather than teaching each renderer to tolerate duplicates.
 */
export function dedupeById<T extends { id: string }>(rows: readonly T[]): T[] {
  const seen = new Set<string>();
  const out: T[] = [];
  for (const row of rows) {
    if (seen.has(row.id)) continue;
    seen.add(row.id);
    out.push(row);
  }
  return out;
}
